<template>
  <v-layout
    searchbar
    class="flex-row fill-height justify-end px-4 no-x-margin bg-white"
    :class="[
      background,
      { backgroundHighlight: searchModel != '' && searchModel != undefined },
      { 'align-center': !isAutocomplete },
    ]"
  >
    <AutocompleteFilter
      v-if="isAutocomplete"
      :placeholder="searchTitle"
      :elements="autocompleteItems"
      :return-object="true"
      :hide-no-data="true"
      :resetOnSelect="resetOnSelect"
      :autoCompletePreSelect="autoCompletePreSelect"
      type="searchbar"
      :clearOnCloseDrawer="clearOnCloseDrawer"
      @searchItems="searchItems"
      @confirm="confirm"
      @setValue="setValue"
      @cleared="cleared"
      ref="autocomplete"
      :max-width="maxWidth"
      :label="label"
    />
    <input
      v-else
      class="searchbar-input-search pl-4"
      :class="{
        searchingTextColor:
          searchModel != '' && searchModel != undefined && !isFilterActive,
        caretDefault: searchModel == '' || searchModel == undefined,
      }"
      data-qa="input-search"
      :value="searchModel"
      type="text"
      v-bind:placeholder="searchTitle"
      @keyup="emitInput"
      ref="input"
    />
    <v-icon
      v-if="iconEnabled"
      :color="
        searchModel != '' && searchModel != undefined
          ? 'var(--color-wt)'
          : 'var(--col-highlight)'
      "
      >{{ icon }}</v-icon
    >
  </v-layout>
</template>

<script lang="ts">
import AutocompleteFilter from "../AutocompleteFilter.vue";

export default {
  name: "Searchbar",
  components: {
    AutocompleteFilter,
  },
  data() {
    return {
      model: "",
      search: "",
    };
  },
  methods: {
    emitInput(event) {
      this.$emit("setValue", event.target.value);
      if (this.confirmEnabled && event.key === "Enter") {
        this.$emit("confirm", event.target.value);
      }
    },
    clear() {
      if (this.$refs.input) {
        (this.$refs.input as HTMLInputElement).value = "";
      }
    },
    searchItems(s: string) {
      this.$emit("autocomplete-search", s);
    },
    confirm(el) {
      this.$emit("confirm", el);
    },
    setValue(el) {
      this.$emit("setValue", el);
    },
    cleared(el) {
      this.$emit("cleared", el);
    },
  },
  props: {
    background: {
      type: String,
      default: "bg-g1",
    },
    confirmEnabled: {
      type: Boolean,
      default: false,
    },
    clearOnConfirm: {
      type: Boolean,
      default: true,
    },
    clearOnCloseDrawer: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "ecc:ecc-TB-Find",
    },
    iconEnabled: {
      type: Boolean,
      default: true,
    },
    searchTitle: {
      type: String,
      default: "Search...",
    },
    searchModel: {
      type: String,
    },
    autoCompletePreSelect: {
      type: String,
      default: "",
    },
    isFilterActive: {
      type: Boolean,
      default: false,
    },
    isAutocomplete: {
      type: Boolean,
      default: false,
    },
    autocompleteItems: {
      type: Array,
      default: () => [],
    },
    resetOnSelect: {
      type: Boolean,
      default: () => true,
    },
    maxWidth: {
      type: String,
      default: undefined,
    },
    label: {
      type: String,
      default: undefined,
    },
  },
};
</script>


<style scoped>
.searchbar input {
  outline: none;
  /* width: 100%; */
  flex-grow: 1;
}
.backgroundHighlight {
  background-color: var(--color-highlight) !important;
}
.backgroundColor {
  background-color: var(--background);
}
.caretDefault {
  caret-color: var(--color-dk);
}
.searchingTextColor {
  color: var(--color-wt);
  caret-color: var(--color-wt);
}
.searchbar .v-icon::before {
  font-size: 22px;
}

.autocomplete-filter >>> .v-input.search {
  padding: 0px !important;
  font-size: 12px;
}
.searchbar-input-search {
  width: 100%;
  outline: none;
}
</style>
